import React from 'react';
import PropTypes from 'prop-types';

const AuthModal = ({
  authMode, setAuthMode,
  authEmail, setAuthEmail,
  authPassword, setAuthPassword,
  authError,
  privacyPolicyAccepted, setPrivacyPolicyAccepted,
  onSubmit,
  onSocialLogin,
  onClose,
  onShowPrivacyPolicy,
}) => {
  const titles = { login: 'Accedi', register: 'Registrati', reset_password: 'Reset Password' };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md relative">

        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-red-500 hover:text-red-700 focus:outline-none"
          aria-label="Chiudi"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <h3 className="text-2xl font-bold mb-4 text-red-700 text-center">{titles[authMode]}</h3>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label htmlFor="auth-email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email" id="auth-email" required
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
              value={authEmail} onChange={(e) => setAuthEmail(e.target.value)}
            />
          </div>

          {authMode !== 'reset_password' && (
            <div>
              <label htmlFor="auth-password" className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <input
                type="password" id="auth-password" required
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                value={authPassword} onChange={(e) => setAuthPassword(e.target.value)}
              />
            </div>
          )}

          {authMode === 'register' && (
            <div className="flex items-center">
              <input
                type="checkbox" id="privacy-accept" required
                checked={privacyPolicyAccepted}
                onChange={(e) => setPrivacyPolicyAccepted(e.target.checked)}
                className="form-checkbox h-5 w-5 text-red-600 rounded-md"
              />
              <label htmlFor="privacy-accept" className="ml-2 text-sm text-gray-900">
                Ho letto e accetto la{' '}
                <button type="button" onClick={onShowPrivacyPolicy} className="text-blue-600 hover:underline">
                  Privacy Policy
                </button>
              </label>
            </div>
          )}

          {authError && <p className="text-red-600 text-sm text-center">{authError}</p>}

          <button
            type="submit"
            className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-md shadow-sm transition-colors duration-200"
          >
            {authMode === 'login' ? 'Accedi' : authMode === 'register' ? 'Registrati' : 'Invia Email Reset Password'}
          </button>
        </form>

        {/* Link cambio modalità */}
        {authMode !== 'reset_password' ? (
          <div className="mt-4 text-center text-sm space-y-1">
            <p>
              Non hai un account?{' '}
              <button onClick={() => { setAuthMode('register'); setAuthPassword(''); setPrivacyPolicyAccepted(false); }} className="text-blue-600 hover:text-blue-800 font-medium">
                Registrati
              </button>
            </p>
            <p>
              <button onClick={() => { setAuthMode('reset_password'); setAuthPassword(''); }} className="text-blue-600 hover:text-blue-800 font-medium">
                Password dimenticata?
              </button>
            </p>
          </div>
        ) : (
          <div className="mt-4 text-center text-sm">
            <button onClick={() => { setAuthMode('login'); setAuthPassword(''); }} className="text-blue-600 hover:text-blue-800 font-medium">
              Ricordi la password? Accedi
            </button>
          </div>
        )}

        {/* Social login */}
        <div className="mt-6 text-center">
          <p className="text-gray-600 text-sm mb-3">Oppure accedi con:</p>
          <button
            onClick={() => onSocialLogin('google')}
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md shadow-sm transition-colors duration-200"
          >
            Accedi con Google
          </button>
        </div>
      </div>
    </div>
  );
};

AuthModal.propTypes = {
  authMode: PropTypes.string.isRequired,
  setAuthMode: PropTypes.func.isRequired,
  authEmail: PropTypes.string.isRequired,
  setAuthEmail: PropTypes.func.isRequired,
  authPassword: PropTypes.string.isRequired,
  setAuthPassword: PropTypes.func.isRequired,
  authError: PropTypes.string.isRequired,
  privacyPolicyAccepted: PropTypes.bool.isRequired,
  setPrivacyPolicyAccepted: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSocialLogin: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onShowPrivacyPolicy: PropTypes.func.isRequired,
};

export default AuthModal;
